import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
  apiKey: '320f0b7600e811e605762d382d490fbd',
  plugins: [new BugsnagPluginVue()],
  appVersion: process.env.VERSION,
  releaseStage: process.env.RELEASE,
  notifyReleaseStages: ['production'],
});

Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue);
